import type { Role } from './rbacRoles';

const ENROLLMENT_ROLES: ReadonlySet<Role> = new Set([
  'unify-admin',
  'unify-assistant',
  'practice-owner',
  'practice-admin',
  'practice-assistant',
  'supervisor',
  'provider',
]);

const ENROLLMENT_SELECTOR_ROLES: ReadonlySet<Role> = new Set([
  'unify-admin',
  'unify-assistant',
  'practice-owner',
  'practice-admin',
  'practice-assistant',
]);

export function canAccessEnrollments(role: Role): boolean {
  return ENROLLMENT_ROLES.has(role);
}

export function canSelectEnrollmentPractitioner(role: Role): boolean {
  return ENROLLMENT_SELECTOR_ROLES.has(role);
}
